export type KycStatut = "en_attente" | "valide" | "refuse";

export type Kyc = {
  id: number;
  slug: string;
  user: number;
  user_nom: string | null;
  user_email: string | null;
  type_piece: "cni" | "passeport" | "permis";
  numero_piece: string;
  recto: string | null;
  verso: string | null;
  selfie: string | null;
  statut: KycStatut;
  motif: string | null;
  traite_par: number | null;
  date_soumission: string;
  date_traitement: string | null;
};

// Réponse quand aucun dossier n'a été soumis : le backend renvoie statut null.
export type KycEtat = Kyc | { statut: null; message: string };

export const KYC_STATUT: Record<KycStatut, { label: string; color: string }> = {
  en_attente: { label: "En cours d'examen", color: "#f39c12" },
  valide: { label: "Vérifiée", color: "#0FBF56" },
  refuse: { label: "Refusée", color: "#c0392b" },
};

export const TYPES_PIECE = [
  { value: "cni", label: "Carte nationale d'identité" },
  { value: "passeport", label: "Passeport" },
  { value: "permis", label: "Permis de conduire" },
];
